/* eslint-disable no-plusplus */
import RegisterStatusCard from 'components/molecules/register_status_card';
import React, { useEffect } from 'react';

const RegisterPendingApproval = () => {
  useEffect(() => {
    document.title = 'Cadastro - Conlicitação';

    const ensureWidgetVisibility = () => {
      const chat = document.getElementById('megasac-chat');
      const btn = document.getElementById('megasac-button');

      if (btn) {
        btn.style.display = 'block';
        btn.style.visibility = 'visible';
      }

      if (chat) {
        chat.style.display = 'block';
        chat.style.visibility = 'visible';
      }
    };

    ensureWidgetVisibility();
  }, []);

  const handleOpenSupportChat = () => {
    document.body.classList.remove('hide-tallos');

    const openChat = () => {
      const chat = document.getElementById('megasac-chat');
      const btn = document.getElementById('megasac-button');

      let opened = false;

      if (btn) {
        btn.style.display = 'block';
        btn.style.visibility = 'visible';
        btn.style.opacity = '1';

        btn.click();
        opened = true;
      }

      if (chat) {
        chat.style.display = 'block';
        chat.style.visibility = 'visible';
        chat.style.opacity = '1';
        chat.classList.remove('bounceOut', 'fadeOutRight', 'fadeOut', 'hide');
        chat.classList.add('animated', 'fadeInRight', 'show');

        if (chat.style.display === 'none') {
          chat.style.display = 'block';
        }

        opened = true;
      }

      return opened;
    };

    if (openChat()) return;

    let tries = 15;
    const timer = setInterval(() => {
      const success = openChat();

      if (success) {
        clearInterval(timer);
        return;
      }

      if (tries-- <= 0) clearInterval(timer);
    }, 500);
  };

  return (
    <RegisterStatusCard
      title="Cadastro realizado com sucesso!"
      subtitle="Estamos validando suas informações e avisaremos quando o acesso for liberado."
    >
      <button type="button" className="btn btn-success btn-support" onClick={handleOpenSupportChat}>
        Fale com o suporte
      </button>

      <small className="support-hours">
        Horário de atendimento de segunda a sexta
        <br />
        das 08h às 18h
      </small>
    </RegisterStatusCard>
  );
};

export default RegisterPendingApproval;
